import knowledgeRocket from '../../../assets/images/knowledge-rocket.png';

function RocketIllustration() {
  return (
    <img
      src={knowledgeRocket}
      alt="Students learning on a rocket"
      className="pointer-events-none h-auto w-full max-w-[280px] object-contain mix-blend-lighten sm:max-w-[320px] lg:max-w-[360px] xl:max-w-[400px]"
    />
  );
}

export default RocketIllustration;
